var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoimage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 74,
    viewBox: "0 0 78 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3488",
    "data-name": "Group 3488",
    transform: "translate(-279 -311)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_392",
    "data-name": "Path 392",
    transform: "translate(279 311)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H78V74H0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1 1 L 1 73 L 77 73 L 77 1 L 1 1 M 0 0 L 78 0 L 78 74 L 0 74 L 0 0 Z",
    stroke: "none",
    fill: "#8f8c8d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3468",
    "data-name": "Group 3468",
    transform: "translate(130 52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M25.156,0a1.587,1.587,0,0,1,1.123.533,2.037,2.037,0,0,1,.674,1.6v20a2.251,2.251,0,0,1-.449,1.333A2.173,2.173,0,0,1,25.156,24H1.8a2.173,2.173,0,0,1-1.348-.533A3.223,3.223,0,0,1,0,21.867V2.133A2.251,2.251,0,0,1,.449.8C.9.267,1.123,0,1.8,0ZM7.637,4.8A2.337,2.337,0,0,0,5.84,4a2.337,2.337,0,0,0-1.8.8,3.37,3.37,0,0,0-.674,2.133,3.37,3.37,0,0,0,.674,2.133,2.337,2.337,0,0,0,1.8.8,2.337,2.337,0,0,0,1.8-.8,3.37,3.37,0,0,0,.674-2.133A3.37,3.37,0,0,0,7.637,4.8ZM23.584,20,16.846,8l-6.064,9.333L6.738,13.867,3.369,20Z",
    transform: "translate(174 275)",
    fill: "rgba(134,131,132,0.89)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Upload_Image",
    "data-name": "Upload Image",
    transform: "translate(157.5 314)",
    fill: "rgba(134,131,132,0.89)",
    stroke: "rgba(103,103,103,0)",
    strokeWidth: 1,
    fontSize: 10,
    fontFamily: "Assistant"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Upload Image"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoimage);
export default __webpack_public_path__ + "static/media/noimage.68484f7bc943ad1d5008f1b25d70fca7.svg";
export { ForwardRef as ReactComponent };